import { KeyboardButtonDefinition } from "./KeyboardButton";

export function getInputValue(
    input: HTMLInputElement | HTMLTextAreaElement,
    event: KeyboardButtonDefinition
): string {
    const newValue = (input.value + event.char).replace(/.?\x08/g, "");
    if (input.maxLength > 0) {
        return newValue.substr(0, input.maxLength);
    }
    return newValue;
}
